import { bootstrapApplication } from "@angular/platform-browser";
import config from "devextreme/core/config";
import { AppComponent } from "./app/app.component";
import { appConfig } from "./app/app.config";
import { licenseKey } from "./devextreme-license";

config({ licenseKey });

bootstrapApplication(AppComponent, appConfig).catch((err) =>
  console.error(err),
);
